import ActivityLog from '../components/ActivityLog/ActivitiesLog';

export const DEFAULT_ACTIONS = [
  {
    id: 'activity',
    name: 'Activity',
    icon: 'activity-log-mono',
    color: 'primary-500',
    component: <ActivityLog />
  }
];
